import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(theme => ({
  typeTabs: {
    marginBottom: theme.spacing(2),
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  smallTypeTabs: {
    '&&': {
      minHeight: 36,
    },
  },
  typeTab: {
    '&&': {
      minHeight: 48,
      padding: theme.spacing(1, 2),
      textTransform: 'none',
      color: 'var(--bui-fg-primary)',
      '&:hover': { backgroundColor: theme.palette.action.hover },
    },
  },
  smallTypeTab: {
    '&&': {
      minHeight: 36,
      padding: theme.spacing(0.5, 1.5),
      fontSize: theme.typography.body2.fontSize,
    },
  },
  typeTabName: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  smallTypeTabName: {
    gap: theme.spacing(0.75),
  },
}));
